import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { STORAGE_SERVICE_TOKEN } from '@/core/util/storage.token';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '@/core/model/api-response';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';

/**
 * SRP: owns only HTTP calls related to authentication.
 * No state, no routing — those live in SessionStateService.
 */
@Injectable({ providedIn: 'root' })
export class AuthHttpService {
    private readonly http    = inject(HttpClient);
    private readonly storage = inject(STORAGE_SERVICE_TOKEN);
    private readonly url     = environment.baseUrl;

    login(data: any) {
        return this.http.post<ApiResponse<any>>(`${this.url}/auth/platform/login`, data);
    }

    getUser() {
        return this.http.get<any>(`${this.url}/auth/me`);
    }

    refreshToken() {
        const headers = new HttpHeaders({ Authorization: `Bearer ${this.storage.get(STORAGE_KEYS.REFRESH_TOKEN)}` });
        return this.http.post<any>(`${this.url}/refresh-token`, null, { headers });
    }

    callLogout() {
        const headers = new HttpHeaders({ Authorization: `Bearer ${this.storage.get(STORAGE_KEYS.TOKEN)}` });
        return this.http.get<any>(`${this.url}/log-out`, { headers });
    }
}
